import React from 'react';
import {
  Dialog,
  DialogContent,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import { BaseDialogTitle } from './BaseDialogTitle';
import { BaseTypography } from '../BaseTypography/BaseTypography';
import { BaseDivider } from '../BaseDivider/BaseDivider';

const useStyles = makeStyles({
  root: {
    position: 'relative',
  },
  titleDivider: {
    position: 'relative',
    marginLeft: '-20px',
    width: 'calc(100% + 40px)',
  },
});

const StyledDialog = withStyles((theme) => ({
  paper: {
    boxShadow: '0px 8px 30px rgba(108, 108, 108, 0.15)',
    borderRadius: '6px',
    padding: '30px 20px',
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      margin: '20px',
    },
  },
}))(Dialog);

const StyledDialogContent = withStyles(() => ({
  root: {
    padding: '20px 0 0',
    position: 'relative',
    overflowY: 'visible',
  },
}))(DialogContent);

type BaseDialogProps = {
  open: boolean;
  onClose: () => any;
  title: any;
  paperStyles?: any;
  isFullWidthTitleDivider?: boolean;
  contentStyle?: any;
};

export const BaseDialog: React.FC<BaseDialogProps> = (props) => {
  const {
    open,
    title,
    onClose,
    children,
    paperStyles,
    isFullWidthTitleDivider,
    contentStyle,
  } = props;
  const classes = useStyles();
  return (
    <StyledDialog
      open={open}
      className={classes.root}
      onClose={onClose}
      PaperProps={{ style: paperStyles }}
    >
      <BaseDialogTitle onClose={onClose}>
        <BaseTypography variant="h4">{title}</BaseTypography>
      </BaseDialogTitle>

      {isFullWidthTitleDivider && (
        <BaseDivider className={classes.titleDivider} mBottom="0" />
      )}

      <StyledDialogContent style={contentStyle}>{children}</StyledDialogContent>
    </StyledDialog>
  );
};
